import React, { useContext } from 'react';

import activityIcons from '../icons/activityIcons';
import { FormRadio, BaseForm, FormIconChooser } from '../form';
import { hideTrackerModals } from '../../actions/ui';
import { FormContext } from '../../context/form-context';

const activityList = [
  {
    value: 'bathing',
    label: 'Bathing',
    duration: false
  },
  {
    value: 'changingClothes',
    label: 'Changing Clothes',
    duration: false
  },
  {
    value: 'holdingClothed',
    label: 'Holding Clothed',
    duration: false
  },
  {
    value: 'mouthCare',
    label: 'Mouth Care',
    duration: false
  },
  {
    value: 'reading',
    label: 'Reading',
    duration: true
  },
  {
    value: 'singing',
    label: 'Singing',
    duration: true
  },
  {
    value: 'skinToSkin',
    label: 'Skin to Skin Care',
    duration: true
  },
  {
    value: 'talking',
    label: 'Talking',
    duration: true
  },
  {
    value: 'temperature',
    label: 'Temperature',
    duration: false
  },
  {
    value: 'timeInNICU',
    label: 'Time in NICU',
    duration: true
  },
  {
    value: 'tummyTime',
    label: 'Tummy Time',
    duration: true
  },
  {
    value: 'other',
    label: 'Other',
    duration: true
  }
];
export { activityList };

export default props => {
  const { setChosenActivity, showBasicModal } = props;
  const formContext = useContext(FormContext);

  const onSubmit = values => {
  };

  return (
    <BaseForm onSubmit={onSubmit}>
      <h2>Select Activity</h2>

      <FormIconChooser className="activityIcons">
        {activityList.map((icon, index) => (
          <FormRadio
            key={index}
            name="chooseActivity"
            value={icon.value}
            imageSrc={activityIcons[icon.value]}
            onClick={() => {
              formContext.clearFormContext();
              hideTrackerModals();
              setChosenActivity(icon);
              showBasicModal();
            }}
          >
            {icon.label}
          </FormRadio>
        ))}
      </FormIconChooser>
    </BaseForm>
  );
};
